export default __webpack_public_path__ + "static/media/black.fad82c7e.svg";